import FlowPolicyModel from './FlowPolicyModel';

class FlowPolicyTemplateModel extends FlowPolicyModel {
  get isTemplate() {
    return true;
  }

  createPolicyModel() {
    return this.clonePolicy({ status: 'active' });
  }
}

export default FlowPolicyTemplateModel;
